"use client";

import { usePathname } from "next/navigation";

// Components
import Container from "@/components/container";
import Link from "next/link";
import Image from "next/image";

// Assets
import ImageLogo from "@/assets/images/logo.svg";
import clsx from "clsx";

export default function Header({ navigation }: any) {
  const pathname = usePathname();

  return (
    <header className="fixed top-8 z-50 w-full">
      <Container className="flex items-center justify-between">
        <Link href="/" className="flex items-center gap-x-2">
          <Image src={ImageLogo} alt="Logo" width={96} height={52} />
        </Link>
        <nav>
          <ul className="flex gap-x-4">
            {navigation.map((nav_item) => (
              <li key={nav_item._uid}>
                <Link
                  className={clsx(
                    "text-white font-semibold py-2 px-4 hover:bg-white/10 rounded transition-colors",
                    pathname ===
                      "/" + nav_item.url.cached_url.replace(/\/$/, "")
                      ? "bg-white/10 "
                      : ""
                  )}
                  href={"/" + nav_item.url.cached_url}
                  key={nav_item._uid}
                >
                  {nav_item.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </Container>
    </header>
  );
}
